module.exports = __webpack_public_path__ + "assets/pdf/2013-06_bloomberg.pdf";